<template>
  <button class="btn btn-primary" v-bind="attrs">
    <div class="d-flex align-items-center justify-content-center">
      {{ label }}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-22 -22 44 44"
        preserveAspectRatio="xMidYMid"
        width="16"
        height="16"
        style="shape-rendering: auto; display: block; background: transparent;"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        class="ml-1"
        v-if="loading"
      >
        <circle
          stroke-dasharray="94.24777960769379 33.41592653589793"
          r="20"
          stroke-width="2"
          stroke="#77c8f1"
          fill="none"
          cx="0"
          cy="0"
        >
          <animateTransform
            keyTimes="0;1"
            values="0 0 0;360 0 0"
            dur="1s"
            repeatCount="indefinite"
            type="rotate"
            attributeName="transform"
          ></animateTransform>
        </circle>
      </svg>
    </div>
  </button>
</template>

<script>
export default {
  props: ['loading', 'label'],
  data() {
    return {
      type: 'primary',
    };
  },
  computed: {
    attrs() {
      const {loading, type, ...rest} = this.$attrs;
      return rest;
    },
  },
};
</script>
